import React from 'react';

import { Container, Row, Col } from 'soluble-design-system-base';
import HelpCategoryItem from '../HelpCategoryItem';

export default function HelpCategoriesSection({ helpCategory }) {
    return (
        <section>
            <Container pt={{ xs: 5, lg: 10 }} pb={{ lg: 5 }}>
                <Row>
                    {helpCategory &&
                        helpCategory.map((helpCategoryItem, index) => {
                            return (
                                <Col
                                    key={index}
                                    col={{ xs: 12, lg: 4 }}
                                    className="mb-5">
                                    <HelpCategoryItem
                                        {...helpCategoryItem}></HelpCategoryItem>
                                </Col>
                            );
                        })}
                </Row>
            </Container>
        </section>
    );
}
